"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.urlWithApiConfig = void 0;
const query_string_1 = __importDefault(require("query-string"));
// we can't import ../../package.json it will caused monorepo wrong dep issue
// so we use genversion to create version.js file
const version_1 = __importDefault(require("./version"));
const urlWithApiConfig = (url, config, disableFastSignup, signInProvider) => {
    const { apiKey, apiSecret, chainId } = config;
    return query_string_1.default.stringifyUrl({
        url,
        query: Object.assign(Object.assign(Object.assign(Object.assign({ disableFastSignup,
            sdkVersion: version_1.default }, (chainId && { network: chainId })), (apiKey && { k: btoa(apiKey) })), (apiSecret && { s: btoa(apiSecret) })), (signInProvider && { provider: signInProvider })),
    });
};
exports.urlWithApiConfig = urlWithApiConfig;
